interface ParametroDestacado {
  key: string;
  label: string;
  value: string;
}

// TODO: remover após implementação de campos dinâmicos — a chave é específica da Loft.
const parametrosEmDestaque = [
  { key: 'numero_contrato_loft', label: 'Número do contrato' },
] as const;

export function selecionarParametrosDestacados(
  agentInput: Record<string, unknown> | null,
): ParametroDestacado[] {
  return parametrosEmDestaque.flatMap(({ key, label }) => {
    const rawValue = agentInput?.[key];
    if (
      typeof rawValue !== 'string' &&
      typeof rawValue !== 'number' &&
      typeof rawValue !== 'boolean'
    ) {
      return [];
    }

    const value = String(rawValue).trim();
    return value ? [{ key, label, value }] : [];
  });
}
